export const services = [
  {
    id: 'design-development',
    title: 'Website Design & Development',
    short:
      'Professional custom websites designed around your business and your customers.',
    whoFor:
      'Small businesses that need a professional first website or a completely custom website built from the ground up.',
    included: [
      'Discovery and planning',
      'Custom website design',
      'Responsive development',
      'Contact forms and conversion-focused calls-to-action',
      'Basic SEO setup',
      'Launch and deployment',
      'Post-launch guidance',
    ],
    outcome:
      'A polished, mobile-friendly website that represents your business professionally and helps customers take action.',
    priceLabel: 'Website packages from $900',
    ctaLabel: 'View Pricing Options',
    ctaTo: '/pricing',
  },
  {
    id: 'redesigns',
    title: 'Website Redesigns',
    short:
      'Refresh an outdated website with a cleaner design and better customer experience.',
    whoFor:
      'Businesses with an existing website that feels outdated, slow, difficult to navigate, or no longer reflects their brand.',
    included: [
      'Review of your existing website',
      'Content and structure recommendations',
      'Modern responsive redesign',
      'Performance improvements',
      'Mobile optimization',
      'Migration planning',
      'Relaunch support',
    ],
    outcome:
      'A faster, cleaner, more modern website that better represents your business and improves the customer experience.',
    note:
      "Every redesign is different. After reviewing your current website and goals, I'll provide a personalized proposal based on the scope of work.",
    priceLabel: 'Custom Quote',
    packageSlug: 'redesign',
  },
  {
    id: 'hosting-support',
    title: 'Managed Hosting + Support',
    short:
      'Professional hosting, maintenance, and support without the technical hassle.',
    whoFor:
      'Business owners who want their website professionally managed without worrying about hosting, updates, or technical maintenance.',
    included: [
      'Secure cloud hosting',
      'SSL certificate',
      'Automatic backups',
      'Security updates',
      'Uptime monitoring',
      'Minor content updates',
      'Technical support',
    ],
    outcome:
      'Peace of mind knowing your website stays online, secure, backed up, and professionally maintained.',
    note:
      'Essential Hosting ($25/month) is also available on the Pricing page for hosting without ongoing content updates and support.',
    priceLabel: 'Starting at $39/month',
    packageSlug: 'hosting',
  },
  {
    id: 'custom-features',
    title: 'Custom Web Applications',
    short:
      'Purpose-built software and integrations for needs beyond a marketing website.',
    whoFor:
      'Businesses with unique processes that need portals, dashboards, workflows, or other custom application features.',
    examples: [
      'Client portals',
      'Admin dashboards',
      'Booking systems',
      'Membership areas',
      'API integrations',
      'Automation workflows',
      'Business-specific functionality',
    ],
    included: [
      'Requirements planning',
      'Custom UI development',
      'Workflow implementation',
      'Third-party integrations',
      'Testing',
      'Documentation',
    ],
    outcome:
      'Custom software designed specifically around how your business operates.',
    note:
      'Pricing depends on complexity and scope. Custom Web Applications start at $3,000+. A personalized proposal is provided after discussing your requirements.',
    priceLabel: 'Starting at $3,000+',
    packageSlug: 'growth',
    ctaLabel: 'Start a Project',
  },
];
